// extracted by mini-css-extract-plugin
export default {"shipping":"Wh-z","header":"Xh-z","adjustMarginAndPaddingNewDesign":"Yh-z"};